import { Grid, Stack, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVolumeUp } from "@fortawesome/free-solid-svg-icons";

function playFirstName() {
  var audio = new Audio("donggyun.m4a");
  audio.play();
}

function Abstract() {
  return (
    <Grid
      container
      style={{ marginBottom: "2rem" }}
      sx={{ alignItems: "center" }}
    >
      <Grid
        style={{ minWidth: 210 }}
        size={{
          md: 3,
          xs: 12
        }}>
        <Stack sx={{ alignItems: "center", justifyContent: "center" }}>
          <img src="./profile.jpg" width={200} alt="DongGyun Han" />
        </Stack>
      </Grid>
      <Grid
        style={{ paddingTop: "2vh" }}
        size={{
          md: 9,
          xs: 12
        }}>
        <Typography variant="h5">
          DongGyun
          <sup style={{ fontSize: "60%" }}>
            <FontAwesomeIcon icon={faVolumeUp} onClick={playFirstName} />
          </sup>{" "}
          Han
        </Typography>
        <Typography variant="h6">Lecturer (Assistant Professor)</Typography>
        <Typography variant="h6">Department of Computer Science</Typography>
        <Typography variant="h6">
          Royal Holloway, University of London
        </Typography>
        <br />
        <Typography>
          Dr DongGyun Han is a lecturer (assistant professor) at the{" "}
          <a href="https://www.cs.rhul.ac.uk/" rel="noopener noreferrer">
            Department of Computer Science
          </a>{" "}
          at{" "}
          <a href="https://www.royalholloway.ac.uk/" rel="noopener noreferrer">
            Royal Holloway, University of London
          </a>
          . He is mainly working on software engineering research. His main
          research interests are Empirical Study, AI for Software Engineering
          (AI4SE), Software Engineering for AI (SE4AI), and Code Review. He was
          a research scientist (postdoc) at{" "}
          <a href="https://soarsmu.github.io/" rel="noopener noreferrer">
            SOftware Analytics Research (SOAR) group
          </a>{" "}
          and{" "}
          <a href="https://smc.smu.edu.sg/" rel="noopener noreferrer">
            Secure Mobile Centre
          </a>{" "}
          at{" "}
          <a href="https://www.smu.edu.sg" rel="noopener noreferrer">
            Singapore Management University (SMU)
          </a>
          . Before joining SMU, he was a software development engineer at{" "}
          <a href="https://aws.amazon.com" rel="noopener noreferrer">
            Amazon Web Services
          </a>
          . He completed his PhD at the{" "}
          <a href="https://ucl.ac.uk" rel="noopener noreferrer">
            University College London (UCL)
          </a>
          . He has worked for{" "}
          <a href="https://itc.kaist.ac.kr/" rel="noopener noreferrer">
            KAIST Institute for IT Convergence
          </a>{" "}
          as a researcher after getting his MPhil. at{" "}
          <a href="https://www.ust.hk" rel="noopener noreferrer">
            Hong Kong University of Science and Technology (HKUST).
          </a>
        </Typography>
      </Grid>
    </Grid>
  );
}

export default Abstract;
